<template>
    <v-container fluid data-view="strat.investor_relations.v12019" class="pa-0">
        <div class="hidden-xs-only max primary">
            <div class="banner">
                <div class="title-section">
                    <div class="w-title roboto ls6 font-weight-light text-uppercase">Strategery.</div>
                    <div class="w-subtitle dolo">Better Tools. Better Results.</div>
                </div>
                <v-layout row class="text-center black--text" justify-center align-center fill-height>
                    <div style="width: 70%; font-size: 5.2em; line-height: 90px; margin-top: 8%" class="text-center dolo">
                        <span class="">Our 
                        <span class="secondary--text">mission</span>
                        is to create
                        <span class="accent--text">impactful </span>
                        <span class="amber--text text--darken-2">performance management</span>
                        through simple, beautiful and 
                        <span class="tertiary--text mb-12">intelligent</span>
                        sofware. 
                        </span>
                        <br>
                        <v-btn class="mt-12 t24 pt-1 px-12 roboto" x-large rounded color="amber" @click="openInvestorDeck()">The Strategery Vision</v-btn>
                    </div>
                </v-layout>
            </div>
            <div class="section tlg primary white--text" v-if="launched">
                <v-layout row wrap v-if="news.length > 0">
                    <v-flex xs12 md3 pl-12>
                        <div class="roboto t40 pl-12">News.</div>
                    </v-flex>
                    <v-flex xs12 md9>
                        <v-layout row wrap pr-12 v-for="(n,i) in news" :key="i" class="mb-12">
                            <v-flex xs12 pr-12 mb-6>
                                <v-card height="2" width="100%" color="bgGrey"></v-card>
                            </v-flex>
                            <v-flex xs12>
                                <div class="roboto t32 mb-12">{{n.year}}.</div>
                            </v-flex>
                            <v-flex xs12 md4 pr-8 v-for="(y,i) in n.items" :key="i+'-item'+n.year" mb-8>
                                <v-card flat color="transparent" class="white--text">
                                    <v-card-title class="dolo t40 px-0">{{y.date}}</v-card-title>
                                    <v-card-text class="px-0 white--text">
                                        <span class="roboto t22">
                                            {{y.title}}
                                        </span>
                                    </v-card-text>
                                    <v-card-actions class="px-0">
                                        <v-btn text color="tertiary" rounded>more</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </div>
            <div class="section tsm white text-center black--text">
                <div class="text-center mb-8">
                    <v-avatar size="140" tile>
                        <v-img contain src="../assets/logos/iq/iq_shad2.png" alt="strategery"></v-img>
                    </v-avatar>
                </div>
                <div class="text-center dolo" style="font-size: 6em; line-height: 90px; letter-spacing: -6px;">
                    Invest in <span class="amber--text">knowledge.</span>
                </div>
                <div class="roboto t32 my-12 ls6" style="padding: 0 18%">If you had one shot or one opporunity to seize everything you ever wanted, in one moment, would you capture it or just let it slip?</div>
                <div class="roboto t40 mt-12">
                    <v-btn x-large color="tertiary" rounded class="t24 white--text">Capture it</v-btn>
                </div>
                <div class="roboto t40 mt-12">940.536.7638</div>
                <div class="roboto t40">invest@strategery.com</div>
            </div>
            <div class="section black">
                <v-layout justify-center>
                    <v-flex xs12 md9>
                        <v-layout justify-space-between align-center>
                            <v-flex shrink>
                                <v-layout align-center class="t24 white--text">
                                    <span class="text-uppercase font-weight-light">
                                        <span class="font-weight-black" style="font-size: 2em">Strategery.</span>
                                    </span>
                                    <span class="mx-8">
                                        <v-card flat height="30px" width="1" color="white"></v-card>
                                    </span>
                                    <span class="roboto ls6 amber--text">
                                        Better Tools. Better Results.
                                    </span>
                                </v-layout>
                            </v-flex>
                            <v-flex shrink>
                                <v-layout row wrap justify-end class="white--text">
                                    <v-flex shrink ml-3 class="footer-link">
                                        <span class="text-right t18 lulu mr-4">Terms of Service</span>
                                    </v-flex>
                                    <v-flex shrink ml-3 class="footer-link">
                                        <span class="text-right t18 lulu">Privacy Policy</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap justify-end>
                                    <v-flex xs12 class="text-right grey--text text-darken-1">
                                        <span class="text-right t18 lulu"> © {{cry}} DoloLabs LLC. All Rights Reserved.</span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </div>
            <v-dialog fullscreen v-model="investorDeckDialog">
                <investor-deck @killDeck="killDeck()"/>
            </v-dialog>
        </div>
        <div class="mobi hidden-sm-and-up">
            <div class="banner primary">
                <v-layout row class="text-center white--text" justify-center align-center fill-height>
                    <div style="width: 80%; font-size: 2.5em; line-height: 41px; margin-top: 8%" class="text-center roboto">
                        <span class="">Our 
                        <span class="secondary--text dolo" style="letter-spacing: -1px;">mission</span>
                        is to create
                        <span class="accent--text dolo" style="letter-spacing: -1px;">impactful </span>
                        <span class="amber--text text--darken-2 dolo" style="letter-spacing: -1px;">performance management</span>
                        through simple, beautiful and 
                        <span class="tertiary--text mb-12 dolo" style="letter-spacing: -1px;">intelligent</span>
                        sofware. 
                        </span>
                    </div>
                </v-layout>
            </div>
            <div class="section tlg primary white--text" v-if="launched">
                <v-layout row wrap v-if="news.length > 0">
                    <v-flex xs12 mb-12>
                        <div class="roboto t22 pl-12">News.</div>
                    </v-flex>
                    <v-flex xs12 pl-12 pr-12>
                        <v-layout row wrap v-for="(n,i) in news" :key="i" class="mb-12">
                            <v-flex xs12 pr-12 mb-6>
                                <v-card height="2" width="100%" color="bgGrey"></v-card>
                            </v-flex>
                            <v-flex xs12>
                                <div class="roboto t18 mb-12">{{n.year}}.</div>
                            </v-flex>
                            <v-flex xs12 v-for="(y,i) in n.items" :key="i+'-item'+n.year" mb-8>
                                <v-card flat color="transparent" class="white--text">
                                    <v-card-title class="dolo t22 px-0">{{y.date}}</v-card-title>
                                    <v-card-text class="px-0 white--text">
                                        <span class="roboto t14">
                                            {{y.title}}
                                        </span>
                                    </v-card-text>
                                    <v-card-actions class="px-0 t12">
                                        <v-btn text color="tertiary" rounded class="t12">more</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </div>
            <div class="section tsm white text-center black--text">
                <div class="text-center mb-8">
                    <v-avatar size="70" tile>
                        <v-img contain src="../assets/strat_shad2.png" alt="strategery"></v-img>
                    </v-avatar>
                </div>
                <div class="text-center dolo" style="font-size: 2em; line-height: 40px; letter-spacing: -2.5px;">
                    Invest in <span class="amber--text">knowledge.</span>
                </div>
                <div class="roboto t18 my-12" style="padding: 0 8%">If you had one shot or one opporunity to seize everything you ever wanted, in one moment, would you capture it or just let it slip?</div>
                <div class="roboto t14 mt-12">
                    <v-btn x-large color="tertiary" rounded class="t14 white--text">Capture it</v-btn>
                </div>
                <div class="roboto t22 mt-12">940.536.7638</div>
                <div class="roboto t22">invest@strategery.com</div>
            </div>
        </div>
    </v-container>
</template>

<script>
import investorDeck from './investor_deck'

export default {
    components: {
        investorDeck
    },
    props: {},
    data: () => {
        return {
            investorDeckDialog: false,
            launched: false,
            news: [
                {
                    year: 2018,
                    items: [
                        {
                            date: '08.12.2018',
                            title: 'Formation of DoloLabs LLC',
                            content: ''
                        },
                        {
                            date: '08.12.2018',
                            title: 'A letter from Josh Olson. A dude that works for DoloLabs LLC',
                            content: ''
                        },
                    ]
                },
                {
                    year: 2019,
                    items: [
                        {
                            date: '02.26.2019',
                            title: 'Something that happened in the beginning of 2019',
                            content: ''
                        },
                        {
                            date: '03.01.2019',
                            title: 'Something else that happened in 2019. And I want to see what happens when it\'s a long title',
                            content: ''
                        },
                        {
                            date: '10.05.2019',
                            title: 'Something else that happened in 2019',
                            content: ''
                        },
                        {
                            date: '12.03.2019',
                            title: 'Q4 & 2019 Fiscal Year Earnings Report',
                            content: ''
                        },
                    ]
                },
                {
                    year: 2020,
                    items: [
                        {
                            date: '01.04.2020',
                            title: 'Something new for the new year',
                            content: ''
                        },
                        {
                            date: '01.21.2020',
                            title: 'This could be an article about Strategery',
                            content: ''
                        },
                    ]
                }
            ]
        }
    },
    methods: {
        openInvestorDeck(){
            this.investorDeckDialog = true
        },
        killDeck(){
            this.investorDeckDialog = false
            //eslint-disable-next-line
            //console.log('investor_relations.methods.killDeck -- hit')
        }
    }
}
</script>

<style lang="scss" scoped>
    .banner {
        height: 98vh;
        width: 100%;

        .title-section {
            position: absolute;
            left: 2%;
            top: 4%;
            width: 50%;
            z-index: 1;

            .w-title {
                font-size: 1.5em;
                line-height: 50px;
            }

            .w-subtitle {
                font-size: 1.5em;
                margin-top: -10px;
            }
        }
        
    }

    .section {
        padding: 125px 0;
        width: 100%;

        &.tsm {
            min-height: 25vh;
        }
        &.tmd {
            min-height: 50vh;
        }
        &.tlg {
            min-height: 90vh;
        }

        .footer-link {
            cursor: pointer;
            color: #9e9e9e !important;
            text-decoration: none !important;

            &:hover {
                color: #FFC107 !important;
                text-decoration: none !important;
            }
        }
    }

    .mobi {
        .banner {
            height: 98vh;
            width: 100%;

            .title-section {
                position: absolute;
                left: 0%;
                top: 2%;
                width: 100%;
                z-index: 1;

                .w-subtitle {
                    font-size: 1.2em;
                    margin-top: -10px;
                }
            }
            
        }

        .section {
            padding: 50px 0;
            width: 100%;

            &.tsm {
                min-height: 25vh;
            }
            &.tmd {
                min-height: 50vh;
            }
            &.tlg {
                min-height: 90vh;
            }

            .footer-link {
                cursor: pointer;
                color: #9e9e9e !important;
                text-decoration: none !important;

                &:hover {
                    color: #FFC107 !important;
                    text-decoration: none !important;
                }
            }
        }
    }
</style>